<template>
  <div class="dv-decoration-7">
    <svg :width="`${51/point}px`" :height="`${50/point}px`">
      <polyline
        stroke-width="4"
        fill="transparent"
        :stroke="mergedColor[0]"
        :points="`${20/point}, 0 ${38/point}, ${20/point} ${20/point}, ${40/point}`"
      />
      <polyline
        stroke-width="2"
        fill="transparent"
        :stroke="mergedColor[1]"
        :points="`${4/point}, 0 ${22/point}, ${20/point} ${4/point}, ${40/point}`"
      />
    </svg>
    <slot></slot>
    <svg :width="`${51/point}px`" :height="`${50/point}px`">
      <polyline
        stroke-width="4"
        fill="transparent"
        :stroke="mergedColor[0]"
        :points="`${20/point}, 0 ${38/point}, ${20/point} ${20/point}, ${40/point}`"
      />
      <polyline
        stroke-width="2"
        fill="transparent"
        :stroke="mergedColor[1]"
        :points="`${4/point}, 0 ${22/point}, ${20/point} ${4/point}, ${40/point}`"
      />
    </svg>
  </div>
</template>

<script>


export default {
  name: 'DvDecoration7',
  props: {
    color: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      defaultColor: ['#1dc1f5', '#1dc1f5'],

      mergedColor: ['#1dc1f5', '#1dc1f5'],
      point: document.body.clientWidth > 2000 ? 0.85 : 2
    }
  }
}
</script>

<style lang="less">
.dv-decoration-7 {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}
</style>
